module.exports = __webpack_public_path__ + "img/Arrow Left.97998885.svg";